import { useSelector } from 'react-redux';

// selectors.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { CountryCode } from '@domains/country';
import { getSelectedAlias } from '../store/slices/domainOrchestratorPricingCommittee.slice';

enum BUSINESS_LINE {
  MARKET_MAKER = 'market-maker',
  INMO = 'inmo',
}

export const useOrchestratorSteps = () => {
  const country = useSelector(getCountry) as CountryCode;
  const selectedAlias = useSelector(getSelectedAlias);

  const marketMakerSteps = [
    'sellers tarea de documentos',
    'idm revision de documentos',
    'remo comite de remodelaciones',
    'idm checks automatico',
    'idm pricing manual',
    'idm pricing automatico',
    'idm hesh',
    'idm ensamble de precio',
    'idm aprobologia',
  ];

  const inmoStepsByCountry: Record<string, string[]> = {
    MX: [
      'idm inmo revision de docs automatico',
      'idm inmo revision docs manual',
      'idm inmo pricing comite automatico',
      'idm inmo pricing comite manual',
      'idm inmo check',
    ],
    CO: [
      'idm inmo revision de docs automatico',
      'idm inmo revision docs manual',
      'idm inmo pricing comite automatico',
      'idm inmo pricing comite manual',
      'idm inmo aprobologia automatica',
    ],
  };

  const inmoSteps = inmoStepsByCountry[country] ?? [];

  const steps =
    selectedAlias === BUSINESS_LINE.MARKET_MAKER ? marketMakerSteps : inmoSteps;

  return { steps };
};
